import React, { Component, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import * as dates from 'date-arithmetic'
import { Navigate } from 'react-big-calendar';
import AdvancedSearchListEvents from './AdvancedSearchListEvents';
import AdvancedSearchListEventsActions from './AdvancedSearchListEventsActions';
import moment from 'moment';
import CardMedicalEvent from './CardMedicalEvent';
import {Container} from 'reactstrap';

class DayComponent extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    console.log("PROPSCALENDAR",this.props);
  }

  componentDidUpdate() {

  }

  render() {

    let { date, events, accessors, localizer } = this.props
    let { messages } = localizer
    let startDay = dates.startOf(date, 'day', 0);
    let endOfDay = dates.endOf(date, 'day', 0);
    events = events.filter(event => event.start >= startDay && event.end <= endOfDay)
    events.sort((a, b) => +accessors.start(a) - +accessors.start(b));
    const ListEventsAdvancedSearchTable = () => {
      return (<>
        {events.map((item, i) => {return (<CardMedicalEvent event={item} className="with-shadow" setDataEvent={this.props.onSelectEvent} />)})}
      </>)
    }

    return (
      <div className="rbc-agenda-view-medical">
        {events.length !== 0 ? (
          <Container>
            <ListEventsAdvancedSearchTable />
          </Container>
        ) : (
          <span className="rbc-agenda-empty">{messages.noEventsInRange}</span>
        )}
      </div>
    );
  }
}

DayComponent.propTypes = {
  events: PropTypes.array,
  length: PropTypes.number.isRequired,
  selected: PropTypes.object,
  accessors: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  getters: PropTypes.object.isRequired,
  localizer: PropTypes.object.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  localizer: PropTypes.any,
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  scrollToTime: PropTypes.instanceOf(Date),
}

DayComponent.navigate = (date, action, { localizer }) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return dates.add(date, -1, 'day')

    case Navigate.NEXT:
      return dates.add(date, 1, 'day')

    default:
      return date
  }
}

DayComponent.range = date => {
  return [dates.startOf(date, 'day')]
}

DayComponent.title = (date, { localizer }) => {
  return moment(date).format('MMMM Do YYYY');
}

export default DayComponent;